export default {
  more: state => state.more,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  messages: state => state.messages,
  foundMembers: state => state.foundMembers,
  removedMembers: state => state.removedMembers,
  isChecked: state => state.isChecked,
  channels: state => state.channels,
  channel: state => state.channel,
  currentChannel: state => state.currentChannel,
  report: state => state.report,
  users: state => state.users,
  moreUsers: state => state.moreUsers,
  userChannelCount: state => state.userChannelCount,
  isAllChecked: state => state.isAllChecked
}



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/getters.js